var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkThin = function SvgCheckmarkThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 18 21 16.5L57 1",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

export default SvgCheckmarkThin;